class GeometryTable {
  constructor(el) {
    this.$current = null;
    this.$el = el;
    this.itemClassName = 'x-product-size__mobile-table-li';
    this.itemActiveClassName = 'x-product-size__mobile-table-li--active';
    this.init();
  }
  init() {
    this.$el.querySelectorAll(`.${this.itemClassName}`).forEach(($item) => {
      if ($item.classList.contains(this.itemActiveClassName)) {
        this.$current = $item;
      }
      $item.addEventListener('click', () => {
        if (this.$current === $item) return;

        if (this.$current) {
          this.$current.classList.remove(this.itemActiveClassName);
        }

        $item.classList.add(this.itemActiveClassName);
        this.$current = $item;
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // product picture slide
  const $slide = document.querySelector('#x-product-variants__slide');
  const sliderConfig = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.x-product-variants__slide-button--next',
      prevEl: '.x-product-variants__slide-button--prev',
    },
    pagination: {
      el: $slide.querySelector('.x-product-variants__slider-pagination'),
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return `<span>${current}/${total}</span>`;
      },
    },
  };
  const variantSlider = new Swiper($slide, sliderConfig);
  const $galleryContainer = document.querySelector('#product-lightgallery');
  let lightGalleryInstance = null;
  function initLightGallery() {
    if (lightGalleryInstance) {
      lightGalleryInstance.destroy();
    }
    lightGalleryInstance = lightGallery($galleryContainer, {
      selector: '.x-product-variants__slide-expand',
      download: false,
      plugins: [],
    });
  }

  function updateColorContent(colorName) {
    if (!colorName) return;

    document.querySelector('#x-product-variants__color-span').textContent = colorName;
  }

  // color swatches
  const colorSelectedClass = 'x-product-variants__color-swatch-item--active';
  const $colorSwatch = document.querySelector('.x-product-variants__color-swatch');
  const $colorSwatchItems = $colorSwatch.querySelectorAll('.x-product-variants__color-swatch-item');
  let $currentColor = null;
  // size swatches
  const sizeItemClass = 'x-product-variants__size-item';
  const sizeSelectedClass = 'x-product-variants__size-item--selected';
  const $sizeSwatch = document.querySelector('.x-product-variants__size-list');
  let $currentSize = null;
  // price and buy-button area
  const $operationArea = document.querySelector('.x-product-variants__precount-operations');

  function reRenderSizeList(sizeList) {
    const currentSizeTitle = $currentSize ? $currentSize.getAttribute('title') : null;
    const sizeHtml = sizeList.reduce((prev, item) => {
      prev.push(`<li
          class='${sizeItemClass} ${currentSizeTitle === item.option2 ? sizeSelectedClass : ''}'
          title="${item.option2}"
          data-id="${item.id}">${item.option2}</li>`);
      return prev;
    }, []);

    $sizeSwatch.innerHTML = sizeHtml.join('');
    // reset current size
    if (currentSizeTitle) {
      $currentSize = $sizeSwatch.querySelector(`.${sizeSelectedClass}`);
    }
  }
  // handle color swatch
  function toggleColorSwatch($item) {
    if ($currentColor) {
      $currentColor.classList.remove(colorSelectedClass);
    }
    $currentColor = $item;
    $currentColor.classList.add(colorSelectedClass);
    updateColorContent($item.getAttribute('title'));
  }

  // handle size swatch
  function toggleSizeSwatch($item) {
    if ($item.classList.contains('x-product-variants__size-item--disabled')) return;
    if ($currentSize) {
      $currentSize.classList.remove(sizeSelectedClass);
    }
    $currentSize = $item;
    $currentSize.classList.add(sizeSelectedClass);
  }
  // update variant info into buy button area
  function updateVariant() {
    let size = '-';
    const color = $currentColor ? $currentColor.getAttribute('title') : '-';
    if ($currentSize) {
      const variantId = $currentSize.getAttribute('data-id');
      const params = { variant: encodeURIComponent(variantId) };
      size = $currentSize.getAttribute('title');

      window.xUtils.updateUrl(params);
    }
    document.querySelector('.x-product-variants__precount-content-describe').innerHTML = `
      <span>${color}</span>
      <span>Size: ${size}</span>
      <span>Quantity: 1</span>
    `;
  }

  function initVariantsSelected() {
    const urlParams = window.xUtils.getUrlParams();
    const variantId = urlParams.variant;
    if (variantId) {
      const variant = window.VARIANTS.find((variant) => variant.id == variantId);
      toggleColorSwatch($colorSwatch.querySelector(`[title="${variant.option1}"]`));
      toggleSizeSwatch($sizeSwatch.querySelector(`[title="${variant.option2}"]`));
    } else {
      $currentColor = $colorSwatch.querySelector(`.${colorSelectedClass}`);
      // do not select default size
      // $currentSize = $sizeSwatch.querySelector(`.${sizeSelectedClass}`);
    }
    const buyBtn = document.querySelector('.x-product__buy-button');
    if (buyBtn) {
      buyBtn.removeAttribute('hidden');
    }
  }

  const $featureList = document.querySelector('.x-product-feature__list');
  const expandClass = 'x-product-feature__item--expand';
  const foldClass = 'x-product-feature__item--fold';
  const FIX_HEIGHT = xUtils.isMobile() ? 24 : 0;
  $featureList.querySelectorAll('.x-product-feature__sub-title').forEach(($title, index) => {
    const $list = $title.parentNode;

    if (!xUtils.isMobile() && index > 0) {
      $list.classList.add(expandClass);
      $list.classList.remove(foldClass);
    }

    if ($list.classList.contains(foldClass)) {
      $list.style.height = $title.offsetHeight + FIX_HEIGHT + 'px';
    } else {
      $list.style.height = $list.scrollHeight + 'px';
    }

    $title.addEventListener('click', function () {
      if ($list.classList.contains(expandClass)) {
        $list.classList.remove(expandClass);
        $list.classList.add(foldClass);
        requestAnimationFrame(() => {
          $list.style.height = $title.offsetHeight + FIX_HEIGHT + 'px';
        });
      } else {
        $list.classList.remove(foldClass);
        $list.classList.add(expandClass);

        requestAnimationFrame(() => {
          $list.style.height = $list.scrollHeight + 'px';
        });
      }
    });
  });

  document.querySelector('#product-geometry-link').addEventListener('click', (e) => {
    const $anchor = document.querySelector('#product-geometry');
    const $list = $anchor.parentNode;

    if (!$list.classList.contains(expandClass)) {
      $list.classList.remove(foldClass);
      $list.classList.add(expandClass);

      requestAnimationFrame(() => {
        $list.style.height = $list.scrollHeight + 'px';
      });
    }
  });

  let $currentSizeItem = null;
  const sizeExpandClass = 'x-product-size__item--expand';
  document.querySelectorAll('.x-product-size__item').forEach(function ($item) {
    const $folder = $item.closest('.x-product-feature__item');

    if ($item.classList.contains(sizeExpandClass)) {
      $currentSizeItem = $item;
    }
    $item.querySelector('.x-product-size__title').addEventListener('click', function () {
      if ($currentSizeItem === $item) {
        $currentSizeItem.classList.remove(sizeExpandClass);
        $currentSizeItem = null;
      } else {
        if ($currentSizeItem) {
          $currentSizeItem.classList.remove(sizeExpandClass);
        }
        $currentSizeItem = $item;
        $currentSizeItem.classList.add('x-product-size__item--expand');
      }
      // set auto to recalculate height
      $folder.style.height = 'auto';
      // reset height
      requestAnimationFrame(() => {
        $folder.style.height = $folder.scrollHeight + 'px';
      });
    });
  });

  document
    .querySelectorAll('.x-product-size__mobile-table-container')
    .forEach(function ($container) {
      new GeometryTable($container);
    });

  const containerSelector = '.x-product-feature__detail';
  const $featureSliderContainer = document.querySelector(containerSelector);
  const featureSliderConfig = xUtils.isMobile()
    ? {
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: false,
          forceToAxis: true,
        },
        scrollbar: {
          el: null,
        },
      }
    : {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: 500,
        nested: true,
        watchSlidesProgress: true,
        grabCursor: true,
        // pagination: {
        //   el: '.x-product-feature__detail-pagination',
        //   type: 'fraction',
        // },
        navigation: {
          nextEl: '.x-product-feature__detail-button-next',
          prevEl: '.x-product-feature__detail-button-prev',
        },
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
          thresholdDelta: 10,
          eventsTarget: containerSelector,
        },
      };
  const featureSlider = new Swiper(containerSelector, featureSliderConfig);

  $featureSliderContainer.addEventListener(
    'wheel',
    (e) => {
      // if scroll to the end, go through
      if (
        (featureSlider.isEnd && e.deltaY > 0) ||
        (featureSlider.isBeginning && e.deltaY < 0) ||
        xUtils.isMobile()
      ) {
        return;
      }

      e.preventDefault();

      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        // stop broswser back or forward
        // trigger slide
        if (Math.abs(e.deltaX) > 10) {
          if (e.deltaX > 0) {
            featureSlider.slideNext();
          } else {
            featureSlider.slidePrev();
          }
        }
      } else {
        if (e.deltaY > 0) {
          featureSlider.slideNext();
        } else {
          featureSlider.slidePrev();
        }
      }
    },
    { passive: false }
  );

  const $slider = document.querySelector('.x-product-review');
  const mediaSliderConfig = xUtils.isMobile()
    ? {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
        },
        scrollbar: {
          el: null,
        },
      }
    : {
        slidesPerView: 'auto',
        spaceBetween: 16,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
        },
        navigation: {
          prevEl: '.x-product-slider__pagination-prev',
          nextEl: '.x-product-slider__pagination-next',
        },
      };
  if ($slider) {
    const mediaSlider = new Swiper($slider, mediaSliderConfig);
    // mediaSlider.el.querySelector('.x-product-slider__pagination').addEventListener('click', (e) => {
    //   const btn = e.target.closest('.x-product-slider__dot');
    //   if (btn) {
    //     mediaSlider.slideTo(btn.dataset.index - 1);
    //   }
    // });
    $slider.addEventListener(
      'wheel',
      (e) => {
        if (
          (mediaSlider.isEnd && e.deltaY > 0) ||
          (mediaSlider.isBeginning && e.deltaY < 0) ||
          xUtils.isMobile()
        ) {
          return;
        }
        e.preventDefault();
      },
      { passive: false }
    );
  }

  function updateButtonStatus(isAvailable) {
    // disable electric logic
    if (!$operationArea) return;
    const $hiddenInput = $operationArea.querySelector('.product-variant-id');
    const $buyBtn = $operationArea.querySelector('.x-product__buy-button');
    const $buyBtnText = $operationArea.querySelector('.x-buy-button-text');

    if (!$currentSize) {
      // if no choose current size, reset
      if ($hiddenInput) $hiddenInput.value = ''; // reset Variant ID, prevent submit
      if ($buyBtnText) $buyBtnText.textContent = 'Choose Options';
      if ($buyBtn) {
        $buyBtn.setAttribute('data-ready', 'false');
        $buyBtn.removeAttribute('disabled');
      }
    } else {
      if ($hiddenInput) $hiddenInput.value = $currentSize.getAttribute('data-id');
      if ($buyBtnText) $buyBtnText.textContent = 'Add to cart';
      if ($buyBtn) {
        $buyBtn.setAttribute('data-ready', 'true');
        if (!isAvailable) {
          $buyBtn.setAttribute('disabled', 'disabled');
          if ($buyBtnText) $buyBtnText.textContent = 'Sold Out';
        } else {
          $buyBtn.removeAttribute('disabled');
          if ($buyBtnText) $buyBtnText.textContent = 'Add to cart';
        }
      }
    }
    updateVariant();
  }
  const variantCache = {};
  function applyVariantHtml(htmlStringObj, onlyUpdatePrice) {
    const { variantSectionHtmlStr, introduceSectionHtmlStr } = htmlStringObj;
    // 1. parse variants html content
    const varaintSectionHtml = new DOMParser().parseFromString(variantSectionHtmlStr, 'text/html');
    const introduceSectionHtml = new DOMParser().parseFromString(
      introduceSectionHtmlStr,
      'text/html'
    );

    // disable electric logic
    if ($operationArea) {
      const $newPriceAndBuyButton = varaintSectionHtml.querySelector(
        '.x-product-variants__precount-operations'
      );
      $operationArea.innerHTML = $newPriceAndBuyButton.innerHTML;
    }

    if (onlyUpdatePrice) return;
    // 2. update area selector
    // 2.1 get variant content dom
    const $newVariantSlide = varaintSectionHtml.querySelector('#x-product-variants__slide');
    const $newVariantSlideItems = $newVariantSlide.querySelectorAll(
      '.x-product-variants__slide-item'
    );
    // 2.2 get video content dom
    const $newVideoContent = introduceSectionHtml.querySelector('#product-video-area');
    const $videoContent = document.querySelector('#product-video-area');
    // 2.3 get feature content dom
    // const $newFeatureContent = html.querySelector('#x-product-feature__detail-layer');
    // const $newFeatureSlideItems = $newFeatureContent.querySelectorAll(
    //   '.x-product-feature__detail-item'
    // );

    // 3. replace old content
    // 3.1 update variant area
    variantSlider.removeAllSlides();
    variantSlider.appendSlide($newVariantSlideItems);
    variantSlider.update();
    variantSlider.slideTo(0, 0);
    initLightGallery();
    // 3.2 update video area
    $videoContent.innerHTML = $newVideoContent.innerHTML;
    // 3.3 update feature area
    // featureSlider.removeAllSlides();
    // featureSlider.appendSlide($newFeatureSlideItems);
    // featureSlider.update();
    // featureSlider.slideTo(0, 0);
  }
  async function fetchVariantData(variantId, onlyUpdatePrice) {
    window.xUtils.showLoading();
    // try to hit cache
    try {
      if (variantCache[variantId]) {
        // 1. if hit cache, render content from cache
        applyVariantHtml(variantCache[variantId], onlyUpdatePrice);

        // 2. get inventory after render
        const inventoryUrl = `${window.location.pathname}?variant=${variantId}&sections=x-variant-inventory`;
        const invRes = await fetch(inventoryUrl);
        const invParsed = await invRes.json();
        // parse str to dom
        const tempDoc = new DOMParser().parseFromString(
          invParsed['x-variant-inventory'],
          'text/html'
        );
        // get inventory json string
        const pureJsonString = tempDoc.body.textContent.trim();
        // parse json string to json object
        const inventoryData = JSON.parse(pureJsonString);

        // 3. update inventory to page
        updateButtonStatus(inventoryData.available);
      } else {
        // 1. no cache, fetch full data
        const variantSectionId = document
          .querySelector('.x-product-variants')
          .id.replace('shopify-section-', '');
        const introduceSectionId = document
          .querySelector('.x-product-introduce')
          .id.replace('shopify-section-', '');
        // const featureSectionId = document.querySelector('.x-product-feature').id.replace('shopify-section-', '');
        const sectionIds = [
          variantSectionId,
          introduceSectionId,
          // featureSectionId,
        ];
        const url = `${window.location.pathname}?variant=${variantId}&sections=${sectionIds.join(',')}`;

        const res = await fetch(url);
        const parsedData = await res.json();
        const variantSectionHtmlStr = parsedData[variantSectionId];
        const introduceSectionHtmlStr = parsedData[introduceSectionId];
        // const featureSectionHtmlStr = parsedData[featureSectionId];
        const strObj = {
          variantSectionHtmlStr,
          introduceSectionHtmlStr,
          // featureSectionHtmlStr,
        };
        // const featureSectionHtml = new DOMParser().parseFromString(featureSectionHtmlStr, 'text/html');
        // set cache
        variantCache[variantId] = strObj;

        // 2. render content
        applyVariantHtml(strObj, onlyUpdatePrice);

        // 3. get inventory from new page
        const variantSectionHtml = new DOMParser().parseFromString(
          variantSectionHtmlStr,
          'text/html'
        );
        const $newBuyBtn = variantSectionHtml.querySelector('.x-product__buy-button');
        const isAvailable = $newBuyBtn && !$newBuyBtn.hasAttribute('disabled');

        // 4. update inventory to page
        updateButtonStatus(isAvailable);
      }
    } catch (e) {
      console.error(e);
    } finally {
      window.xUtils.hideLoading();
    }
  }
  // buy button area
  // cancel hide on buy button area 2026/04/05
  // comment videoArea condition for archive
  function initToggleButtonArea() {
    const $buyButtonArea = document.querySelector('#product-buy-area');
    if (!$buyButtonArea) return;
    // const $videoArea = document.querySelector('#product-video-area');
    const $footerArea = document.querySelector('.x-footer');
    const hideClass = 'x-product-variants__precount---hidden';

    // if (!$buyButtonArea || !$videoArea) return;
    if (!$buyButtonArea) return;

    let isTicking = false;
    const updateButtonVisibility = () => {
      // const videoRect = $videoArea.getBoundingClientRect();
      const footerRect = $footerArea.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const isTopInView = footerRect.top + 160 < viewportHeight;
      // let isTopInView;
      // if (videoRect.bottom + viewportHeight > 0) {
      //   // rect.top + 160 > 0: video area is leaving viewport a few pixels
      //   // rect.top < viewportHeight: video area is entering viewport
      //   isTopInView = videoRect.top + 160 > 0 && videoRect.top < viewportHeight;
      // } else {
      //   isTopInView = footerRect.top + 160 < viewportHeight;
      // }

      if (isTopInView) {
        $buyButtonArea.classList.add(hideClass);
      } else {
        $buyButtonArea.classList.remove(hideClass);
      }

      isTicking = false;
    };
    window.addEventListener('scroll', () => {
      if (!isTicking) {
        requestAnimationFrame(updateButtonVisibility);
        isTicking = true;
      }
    });
  }
  function initVideoAutoPlay() {
    const $videoArea = document.querySelector('#product-video-area');
    const observerOptions = {
      threshold: 0.5, // auto play when visible at least 50%
    };

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $videoContent = document.querySelector('.x-product-introduce-video__content');
        const isVideo = $videoContent.classList.contains(
          'x-product-introduce-video__content-video'
        );
        // get video dom, may be video dom or youtube iframe
        const $desktopVideo = $videoContent.querySelector(
          '.x-product-introduce-video__video--desktop'
        );
        const $mobileVideo = $videoContent.querySelector(
          '.x-product-introduce-video__video--mobile'
        );
        const $ytIframe = $videoContent.querySelector('iframe');
        if (entry.isIntersecting) {
          if (isVideo) {
            xUtils.isMobile()
              ? $mobileVideo.play().catch((e) => console.log('Autoplay blocked:', e))
              : $desktopVideo.play().catch((e) => console.log('Autoplay blocked:', e));
          } else {
            $ytIframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              '*'
            );
          }
        } else {
          // if (isVideo) {
          //   xUtils.isMobile()
          //     ? $mobileVideo.pause().catch((e) => console.log('Pause blocked:', e))
          //     : $desktopVideo.pause().catch((e) => console.log('Pause blocked:', e));
          // } else {
          //   $ytIframe.contentWindow.postMessage(
          //     '{"event":"command","func":"pauseVideo","args":""}',
          //     '*'
          //   );
          // }
        }
      });
    }, observerOptions);

    videoObserver.observe($videoArea);
  }
  function initStoryVideoAutoPlay() {
    const $storyVideoArea = document.querySelectorAll('.x-product-introduce-quality__video-layer');
    const observerOptions = {
      threshold: 0.2,
    };
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $target = entry.target;
        const $desktopVideo = $target.querySelector('.x-product-introduce-quality__video--desktop');
        const $mobileVideo = $target.querySelector('.x-product-introduce-quality__video--mobile');
        if (entry.isIntersecting) {
          xUtils.isMobile()
            ? $mobileVideo.play().catch((e) => console.log('Autoplay blocked:', e))
            : $desktopVideo.play().catch((e) => console.log('Autoplay blocked:', e));
        }
      });
    }, observerOptions);

    $storyVideoArea.forEach(($areaItem) => {
      videoObserver.observe($areaItem);
    });
  }
  // add event handler
  // init components status and interactive
  function init() {
    // init color items event handler
    // something will be changed after color changed: url, content, item's state
    $colorSwatchItems.forEach(($item) => {
      $item.addEventListener('click', () => {
        if ($currentColor === $item) return;

        const title = $item.getAttribute('title');
        const sizeList = window.VARIANTS.filter((variant) => variant.option1 === title);
        const sizeName = $currentSize ? $currentSize.getAttribute('title') : sizeList[0].option2;
        const currentVariant = sizeList.find((variant) => variant.option2 === sizeName);
        fetchVariantData(currentVariant.id);
        toggleColorSwatch($item);
        reRenderSizeList(sizeList);
      });
    });

    // init size items event handler
    // something will be changed after size changed: url, item's state
    $sizeSwatch.addEventListener('click', (e) => {
      const $item = e.target;
      if ($item.classList.contains(sizeItemClass)) {
        if ($currentSize === $item) return;
        fetchVariantData($item.dataset.id, true);
        toggleSizeSwatch($item);
      }
    });
    // lead to size area while clicking submit button and size is not selected
    document.addEventListener('submit', (e) => {
      // 1. check if it's a cart add form
      const targetForm = e.target.closest('form[data-type="add-to-cart-form"]');
      if (!targetForm) return;

      // 2. check if size is selected
      if (!$currentSize) {
        e.preventDefault(); // prevent form submit
        e.stopPropagation();

        // 3. scroll to size area
        const sizeArea = document.querySelector('.x-product-variants__size');
        if (sizeArea) {
          // give size area a little space
          const y = sizeArea.getBoundingClientRect().top + window.scrollY - 300;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    });
    initLightGallery();
    initVariantsSelected();
    initToggleButtonArea();
    initVideoAutoPlay();
    initStoryVideoAutoPlay();
  }

  init();
});
